/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-lights-stroboscope block)");
/* eslint-enable no-console */


(function () {
    function init() {
        const speedEl = document.getElementById('sb-speed');
        if (!speedEl) return;
        const intensityEl = document.getElementById('sb-intensity');
        const colorA = document.getElementById('sb-color-a');
        const colorB = document.getElementById('sb-color-b');
        const modeEl = document.getElementById('sb-mode');
        const toggleBtn = document.getElementById('sb-toggle');
        const stopBtn = document.getElementById('sb-stop');
        const previewBtn = document.getElementById('sb-preview');
        const flash = document.getElementById('sb-flash');
        const screen = document.getElementById('sb-screen');
        const speedVal = document.getElementById('sb-speed-val');
        const intensityVal = document.getElementById('sb-intensity-val');
        const fsBtn = document.getElementById('sb-fs-btn');
        const fsExpand = document.getElementById('sb-fs-expand');
        const fsCompress = document.getElementById('sb-fs-compress');

        let running = false, rafId = null, startTime = 0;

        const clamp = (v, mn, mx) => Math.min(mx, Math.max(mn, v));

        function updateUI() {
            const hz = clamp(parseFloat(speedEl.value), 0.2, 3);
            speedEl.value = hz.toFixed(1);
            speedVal.textContent = `${hz.toFixed(1)} Hz`;
            intensityVal.textContent = `${intensityEl.value}%`;
        }

        function paint(opacity, color) {
            flash.style.opacity = opacity.toFixed(3);
            flash.style.background = color;
            screen.style.background = modeEl.value === 'alternate' ? colorB.value : '#000';
        }

        function animate(now) {
            if (!running) return;
            if (!startTime) startTime = now;
            const elapsed = (now - startTime) / 1000;
            const hz = clamp(parseFloat(speedEl.value), 0.2, 3);
            const amp = parseInt(intensityEl.value, 10) / 100;
            const phase = (elapsed * hz) % 1;
            let opacity = 0, color = colorA.value;

            if (modeEl.value === 'flash') {
                opacity = phase < 0.5 ? amp : 0;
            } else if (modeEl.value === 'pulse') {
                opacity = ((Math.sin(elapsed * hz * Math.PI * 2) + 1) / 2) * amp;
            } else {
                opacity = amp;
                color = phase < 0.5 ? colorA.value : colorB.value;
            }

            paint(opacity, color);
            rafId = requestAnimationFrame(animate);
        }

        function start() {
            if (running) return;
            running = true; startTime = 0;
            toggleBtn.textContent = 'Running';
            rafId = requestAnimationFrame(animate);
        }

        function stop() {
            running = false;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null; startTime = 0;
            toggleBtn.textContent = 'Start';
            paint(0, colorA.value);
        }

        function previewOnce() {
            stop();
            const amp = parseInt(intensityEl.value, 10) / 100;
            paint(amp, colorA.value);
            setTimeout(() => { if (!running) paint(0, colorA.value); }, 180);
        }

        function updateFsIcons() {
            const fs = !!document.fullscreenElement;
            fsExpand.style.display = fs ? 'none' : 'block';
            fsCompress.style.display = fs ? 'block' : 'none';
            fsBtn.setAttribute('aria-label', fs ? 'Exit full screen' : 'Full screen');
        }

        fsBtn.addEventListener('click', () => {
            if (!document.fullscreenElement) screen.requestFullscreen().catch(() => { });
            else document.exitFullscreen().catch(() => { });
        });

        document.addEventListener('fullscreenchange', updateFsIcons);

        [speedEl, intensityEl, colorA, colorB, modeEl].forEach(el => {
            el.addEventListener('input', updateUI);
            el.addEventListener('change', updateUI);
        });

        toggleBtn.addEventListener('click', () => running ? stop() : start());
        stopBtn.addEventListener('click', stop);
        previewBtn.addEventListener('click', previewOnce);

        updateUI();
        paint(0, colorA.value);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
}());